class Dictionaries {
    static EN = {
        ClearStorage: 'Clear storage and reload',
        Code: 'EN',
        DaysOffDuration: 'Number of days off:',
        Duration: 'Shift duration (days):',
        FirstDay: 'Shift first day:',
        ModalFooterPartOne: 'For my little sister,',
        ModalFooterPartTwo: 'Mykhailo Zeleniuk | 2019',
        Months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        Name: 'Jaconn',
        NotSelected: 'not selected',
        Print: 'Print',
        ProjectInfoParagraphOne: 'Welcome to Jaconn - a simple working scheduler.',
        ProjectInfoParagraphTwo: 'It is easy to create your working schedule:',
        ProjectInfoParagraphThree: '1. Select any first day of your working schedule in our user-friendly day-picker;',
        ProjectInfoParagraphFour: '2. Select the duration of your working shift (in days);',
        ProjectInfoParagraphFive: '3. Select the duration of your days-off (in days);',
        ProjectInfoParagraphSix: '4. Select the alternation of working shifts;',
        ProjectInfoParagraphSeven: '5. Validate the selected data is correct and submit the form;',
        ProjectInfoParagraphEight: '6. Enjoy you work schedule.',
        ProjectInfoParagraphNine: 'Please note a working schedule is built by the year of your first working day selected. To build a working schedule, for example, for 2018 - please select a first day of your working schedule in 2018.',
        ProjectInfoParagraphTen: 'If you experience any scheduler issues please try to reset the Application data:',
        SelectDaysOffDuration: 'Select number of days off',
        SelectDuration: "Select shift's duration (days)",
        SelectFirstDay: "Select shift's first day",
        SelectShiftsAlternation: 'Select the alternation of day and night shifts',
        ShiftsAlternation: 'The alternation of day and night shifts:',
        ShiftsAlternationOptionOne: 'None',
        ShiftsAlternationOptionTwo: 'Yes, start with day shift',
        ShiftsAlternationOptionThree: 'Yes, start with night shift',
        Submit: 'Submit',
        Summary: 'Summary',
        WeekdaysLong: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        WeekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        WorkingDaysMarkerExample: 'Working days will be marked as:',
        WorkingNightsMarkerExample: 'Working nights will be marked as:',
        WorkloadSetupHeader: 'Workload setup'
    };

    static UA = {
        ClearStorage: 'Очистити дані та перезавантажити',
        Code: 'UA',
        DaysOffDuration: 'Кількість вихідних днів:',
        Duration: 'Тривалість зміни (днів):',
        FirstDay: 'Перший день зміни:',
        ModalFooterPartOne: 'Присвячую своїй молодшій сестрі,',
        ModalFooterPartTwo: 'Зеленюк Михайло | 2019',
        Months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        Name: 'Jaconn',
        NotSelected: 'не обрано',
        Print: 'Друк',
        ProjectInfoParagraphOne: 'Ласкаво просимо до Jaconn - простого планувальника робочого розкладу.',
        ProjectInfoParagraphTwo: 'Створити свій робочий розклад дуже просто:',
        ProjectInfoParagraphThree: '1. Виберіть будь-який перший день свого робочого графіка в нашому зручному календарі;',
        ProjectInfoParagraphFour: '2. Виберіть тривалість робочої зміни (у днях);',
        ProjectInfoParagraphFive: '3. Виберіть тривалість вихідних днів (у днях);',
        ProjectInfoParagraphSix: '4. Виберіть режим чергування робочих змін;',
        ProjectInfoParagraphSeven: '5. Перевірте правильність вибраних даних та відправте форму;',
        ProjectInfoParagraphEight: '6. Насолоджуйтесь Вашим робочим графіком.',
        ProjectInfoParagraphNine: 'Зверніть увагу, що робочий розклад формується за роком вибору першого робочого дня. Щоб сформувати робочий розклад, наприклад, за 2018 рік - будь ласка, виберіть перший день свого робочого розкладу в 2018 році.',
        ProjectInfoParagraphTen: 'Якщо у Вас виникли проблеми з формуванням розкладу - спробуйте очистити дані сайту:',
        SelectDaysOffDuration: 'Оберіть кількість вихідних днів',
        SelectDuration: 'Оберіть тривалість зміни (днів)',
        SelectFirstDay: 'Оберіть перший день зміни',
        SelectShiftsAlternation: 'Оберіть чергування денних та нічних змін',
        ShiftsAlternation: 'Чергування денних та нічних змін:',
        ShiftsAlternationOptionOne: 'Немає',
        ShiftsAlternationOptionTwo: 'Так, почати з денної зміни',
        ShiftsAlternationOptionThree: 'Так, почати з нічної зміни',
        Submit: 'Підтвердити',
        Summary: 'Огляд',
        WeekdaysLong: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', "П'ятниця", 'Субота'],
        WeekdaysShort: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        WorkingDaysMarkerExample: 'Так будуть позначені денні зміни:',
        WorkingNightsMarkerExample: 'Так будуть позначені нічні зміни:',
        WorkloadSetupHeader: 'Налаштування робочої зміни'
    };
}

export { Dictionaries };
